@if (vista; as v) {
  <section class="detalle">
    <!-- Resumen: estado y lo más consultado. La identidad (identificación,
         patente, línea, cliente, estado operativo) está en el encabezado. -->
    <app-dt-card>
      <app-dt-datos destacado>
        <app-dt-dato etiqueta="Conexión" ocultarVacio>
          <app-dt-estado
            [tono]="v.conexion.tono"
            [etiqueta]="v.conexion.etiqueta"
          />
        </app-dt-dato>
        <app-dt-dato
          etiqueta="Último reporte"
          [valor]="v.hace ? 'hace ' + v.hace : null"
        >
          @if (v.ultimoReporte) {
            <span class="dt-muted fecha">{{ v.ultimoReporte }}</span>
          }
        </app-dt-dato>
        <app-dt-dato
          etiqueta="Recorrido"
          [valor]="v.recorrido.tono ? null : v.recorrido.etiqueta"
          ocultarVacio
        >
          @if (v.recorrido.tono; as tono) {
            <app-dt-estado [tono]="tono" [etiqueta]="v.recorrido.etiqueta" />
          }
        </app-dt-dato>
      </app-dt-datos>
    </app-dt-card>

    <div class="grilla">
      <div class="columna">
        <app-dt-card titulo="Colectivo" icono="directions_bus">
          @if (v.fotos.length) {
            <div class="fotos">
              @for (foto of v.fotos; track $index) {
                <!-- Como la foto del conductor en vehículos -->
                <img
                  [src]="foto"
                  [alt]="'Foto ' + ($index + 1) + ' del colectivo'"
                  class="foto irx-clickeable"
                  role="button"
                  tabindex="0"
                  loading="lazy"
                  (click)="abrirFoto($index)"
                  (keydown.enter)="abrirFoto($index)"
                  title="Ver foto"
                />
              }
            </div>
            <app-image-viewer
              [images]="v.fotos"
              [index]="indiceFoto"
              (indexChange)="indiceFoto = $event"
              [isVisible]="verFotos"
              [altText]="colectivo?.identificacion"
              (closeViewer)="verFotos = false"
            ></app-image-viewer>
          }
          <app-dt-datos>
            <app-dt-dato etiqueta="Marca y modelo" [valor]="v.marcaModelo" />
            <app-dt-dato etiqueta="Año" [valor]="v.anio" />
          </app-dt-datos>
        </app-dt-card>

        <app-dt-card titulo="Tracker" icono="gps_fixed">
          @if (v.tracker; as t) {
            <app-dt-datos>
              <app-dt-dato etiqueta="Nombre" [valor]="t.nombre">
                @if (puedeVerTracker && t.id) {
                  <a
                    irxBotonIcono
                    tamano="mini"
                    [routerLink]="[
                      '/main/administracion/trackers/detallesTracker',
                      t.id,
                    ]"
                    tooltip="Ver detalle del tracker"
                  >
                    <mat-icon>visibility</mat-icon>
                  </a>
                }
              </app-dt-dato>
              <app-dt-dato etiqueta="Tipo" [valor]="t.tipo" />
              <app-dt-dato
                etiqueta="ID único"
                [valor]="t.uniqueId"
                mono
                copiable
              />
              <app-dt-dato
                etiqueta="Frecuencia de reporte"
                [valor]="t.frecuencia"
              />
            </app-dt-datos>
          } @else {
            <span class="dt-muted">Sin tracker asignado</span>
          }
        </app-dt-card>
      </div>

      <!-- Mapa: llena el alto de la columna (altoMapa, ver detalle de
           tracker) -->
      <div class="mapa" #contenedorMapa>
        <app-map-card
          [height]="pantallaAncha() && altoMapa() ? altoMapa() + 'px' : '360px'"
          [config]="mapCardConfig"
          [loading]="loadingMapa()"
        ></app-map-card>
      </div>
    </div>

    <!-- Recorrido asignado, a lo ancho: con los horarios no entra en una
         columna -->
    <app-dt-card titulo="Recorrido" icono="route">
      @if (v.ruta; as r) {
        <app-dt-datos>
          <app-dt-dato etiqueta="Nombre" [valor]="r.nombre">
            @if (r.color) {
              <span class="muestra-color" [style.background]="r.color"></span>
            }
          </app-dt-dato>
          <app-dt-dato etiqueta="Destino" [valor]="r.destino" />
          @if (r.por) {
            <app-dt-dato etiqueta="Por" [valor]="r.por" />
          }
        </app-dt-datos>
        @if (r.horarios.length) {
          <div class="horarios">
            @for (h of r.horarios; track $index) {
              <div class="horario">
                <span class="horario-dia">{{ h.dia }}</span>
                <span>{{ h.horario }}</span>
                @if (h.frecuencia) {
                  <span class="dt-muted">{{ h.frecuencia }}</span>
                }
              </div>
            }
          </div>
        } @else {
          <span class="dt-muted">Sin horarios cargados</span>
        }
      } @else {
        <span class="dt-muted">Sin recorrido asignado</span>
      }
    </app-dt-card>
  </section>
}
